import {
  SAVE_ELEMENTS_STORE,
  SAVE_SCALES,
  MERGE_DATA_GEO,
  SAVE_DATA,
  SAVE_DATA_GEO,
  FETCH_SUCCESS,
  CHANGE_CURRENT_KEY,
  CHANGE_CURRENT_SCALE,
  // CHANGE_PARAMETER_FILTER,
} from '../constants/ActionTypes';

const initialState = {
  list: {},
  listMerge: [],
  loading: false,
  elements: null,
  scales: {},
  param: {
    currentKey: null,
    currentScale: null,
  },
  dataGeo: {
    municipios: {},
    estados: {},
  },
  data: {
    vencedores: {},
  },
};

export default function initialReducer(state = initialState, action) {
  const { type } = action;
  switch (type) {
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: true,
        list: action.payload,
      };

    case SAVE_ELEMENTS_STORE:
      return {
        ...state,
        elements: action.payload,
      };

    case SAVE_SCALES:
      return {
        ...state,
        scales: action.payload,
      };

    // case CHANGE_PARAMETER_FILTER:
    //   return {
    //     ...state,
    //     filters: {
    //       ...state.filters,
    //       individual: action.payload
    //     },
    //   };

    case MERGE_DATA_GEO:
      return {
        ...state,
        listMerge: action.payload,
      };

    case SAVE_DATA:
      return {
        ...state,
        data: {
          ...state.data,
          vencedores: action.payload.vencedores,
        },
      };

    case SAVE_DATA_GEO:
      return {
        ...state,
        dataGeo: {
          ...state.dataGeo,
          municipios: action.payload.municipios,
          estados: action.payload.estados,
        },
      };

    case CHANGE_CURRENT_KEY:
      return {
        ...state,
        param: { ...state.param, currentKey: action.payload },
      };

    case CHANGE_CURRENT_SCALE:
      return {
        ...state,
        param: { ...state.param, currentScale: action.payload },
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/initial.js